import { useMutation } from '@tanstack/react-query';
import { fetchWithCsrfRetry, handleApiResponse } from '@shared/hooks/utils';

interface StopImpersonationResponse {
  success: boolean;
  message: string;
  error?: string;
}

export const useStopImpersonation = () => {
  return useMutation<StopImpersonationResponse, Error, void>({
    mutationFn: async () => {
      const response = await fetchWithCsrfRetry('/api/impersonation', {
        method: 'DELETE',
      });

      return handleApiResponse(response, {
        method: 'DELETE',
        endpoint: '/api/impersonation',
      });
    },
  });
};
